import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { Redirect, Route, Switch } from '@treams/treams-routes';
import { Jumbo, Tabs } from '@treams/treams-ui';

import { useHelicopter } from 'navigation/HelicopterContext';
import { InboxPersonalContainerWithoutSidebar } from 'packages/kakapo-ui-application/pages/inbox/InboxPersonalContainer';
import useAuthenticatedUser from '../packages/kakapo-ui-application/hooks/useAuthenticatedUser';
import useViewerRoles from 'packages/kakapo-ui-application/hooks/useUserRoles';
import Journey from '../journey/Journey';
import { InboxManagerContainerWithoutSidebar } from 'manager/inbox/InboxManagerContainer';

export default function Home() {
	const { t } = useTranslation();
	const authenticatedUser = useAuthenticatedUser();
	const { enabled } = useHelicopter();
	const { isWorkspaceSuperuser, isManager } = useViewerRoles();

	if (enabled) {
		return <Redirect to="/manager" />;
	}

	return (
		<Box>
			<Jumbo
				wide={1440}
				title={t('inbox.page.title', { name: authenticatedUser.firstName })}
				alternativePageTitle={t('home.page.title')}
				footer={
					<Tabs.Container wide={1440}>
						<Tabs.Item title={t('inbox.tab.personal.title')} path="/" />
						{isWorkspaceSuperuser ? (
							<Tabs.Item title={t('inbox.tab.superuser.title')} path="/inbox/manager" />
						) : (
							isManager && <Tabs.Item title={t('inbox.tab.manager.title')} path="/inbox/manager" />
						)}
						<Tabs.Item title={t('inbox.tab.journey.title')} path="/journey" />
					</Tabs.Container>
				}
			/>
			<Switch>
				<Route path="/inbox/manager">
					<Box height="100vh">
						<InboxManagerContainerWithoutSidebar header={false} />
					</Box>
				</Route>
				<Route path="/" exact>
					<Box px={4} py={2}>
						<InboxPersonalContainerWithoutSidebar header={false} />
					</Box>
				</Route>
				<Route path="/journey">
					<Journey jumbo={false} />
				</Route>
			</Switch>
		</Box>
	);
}
